import { call, put, takeLatest } from 'redux-saga/effects';
import { repositories } from 'api';
import * as types from './types';
import { fetchProductsSet as actions } from './actions';

export { actions };

const productsSet = new repositories.ProductsSet();

type Action = {
    type: string;
    payload: string;
};

function* fetchProductsSet(action: Action) {
    try {
        const setData = yield call<any>([productsSet, 'get'], { code: action.payload });

        yield put(actions.success(setData.data));
    } catch (error) {
        yield put(actions.failure(error.response.data));
    }
}

function* productsSetSaga() {
    yield takeLatest<any>(types.FETCH_PRODUCTS_SET_REQUEST, fetchProductsSet);
}

export default productsSetSaga;
